import React from "react";
import CarsList from "../CarsList";
import Driver from "./Driver";
import GreatChoice from "./GreatChoice";
import IncludedPrice from "./IncludedPrice";
import Price from "./Price";
import { shallowEqual, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { infoToast } from "../../../../helpers/toaster";

const CarrentDetails = () => {
  const userData = sessionStorage.getItem("userData")
  //  !==null && JSON.parse(sessionStorage.getItem("userData")) || null
  // useSelector((state) => state.user.userData, shallowEqual);//not
  const navigate = useNavigate();

  React.useEffect(() => {
    if (userData === null) {
      navigate("/carrent");
      infoToast("Please Login First!")
    }
  }, [userData]);

  const carDetail = JSON.parse(sessionStorage.getItem("selectedCar"));

  return (
    <>
      <section className="transfer car-rental-payment">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="transfer-inner-wrap">
                <h4 className="title">Easy Boarding</h4>
                {carDetail !== null && (
                  <>
                    <CarsList carDetail={carDetail} book={false} />
                    <GreatChoice carDetail={carDetail} />
                    <IncludedPrice carDetail={carDetail} />
                    <Driver />
                  </>
                )}
              </div>
            </div>
            {carDetail !== null && <Price />}
          </div>
        </div>
      </section>
    </>
  );
};

export default CarrentDetails;
